/* eslint-disable no-console */
/**
 * IoT PubSub was removed from aws-amplify v6.
 * TODO: Replace with direct AWS IoT SDK or @aws-amplify/pubsub when available.
 * The subscribe functionality is stubbed out so the app compiles; admin real-time
 * updates will not work until a replacement is implemented.
 */
import { SagaIterator } from 'redux-saga';
import { all, put, takeLatest } from 'redux-saga/effects';
import { getApartment, removeApartmentSuccess } from '../actions/apartments';
import { getApplication, getApartmentApplications } from '../actions/applications';
import { initializeIot, initializeIotFail, initializeIotSuccess, onMessage, onMessageFail, onMessageSuccess } from '../actions/iot';
import { PayloadParameters } from '../types/payloads';

function* handleInitializeIot(): SagaIterator {
    try {
        console.warn('IoT PubSub is not available after Amplify v6 migration. Admin real-time updates disabled.');
        yield put(initializeIotSuccess());
    }
    catch (error: any) {
        yield put(initializeIotFail());
    }
}

export interface HandleOnMessageProps {
    topic: string;
    data: any;
}

export function* handleOnMessage({ payload: { topic, data } }: PayloadParameters<HandleOnMessageProps>): SagaIterator {
    try {
        const { apartmentId, userId, applicationId, method } = data;
        if (topic === '/apartments' && apartmentId && userId) {
            if (method === 'update') {
                yield put(getApartment({ userId, apartmentId }));
            }
            else if (method === 'delete') {
                yield put(removeApartmentSuccess(apartmentId));
            }
        }
        else if (topic === '/applications') {
            if (method === 'update') {
                if (apartmentId && applicationId) {
                    yield put(getApplication({ apartmentId, applicationId }));
                }
                else if (apartmentId && !applicationId) {
                    yield put(getApartmentApplications({ apartmentId }));
                }
            }
        }
        yield put(onMessageSuccess());
    }
    catch (error: any) {
        yield put(onMessageFail((error as any).message));
    }
}

function* watchIotActions() {
    yield all([
        takeLatest(initializeIot, handleInitializeIot),
        takeLatest(onMessage, handleOnMessage)
    ]);
}

const iotSagas = [watchIotActions];
export default iotSagas;
